import { IReduxState } from '../../types/redux';

export const workplaceCountValueSelector = (state: IReduxState) => {
  return state.filters.jsonQuery.workplace_count?.value || {};
};
